import {
  Alert,
  AlertTitle,
  Button,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { IconCalendarTime, IconMail, IconWallet } from "@tabler/icons";
import axios from "axios";
import { TailSpin } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import { baseURL } from "src/api/axios";
import DashboardCard from "../../../components/shared/DashboardCard";

const TotalBalance = ({ wallet, user }) => {
  // chart color
  const theme = useTheme();

  const sendVerifyEmail = async () => {
    const email = JSON.parse(localStorage.getItem("store"));
    await axios
      .post(baseURL + "/auth/send-verification-email", {
        email: email?.user?.email || email?.email,
      })
      .then(() => {
        toast.success("Verification email Sent");
      })
      .catch((e) => {
        console.log(e);
        toast.error("Failed to send Email", { position: "bottom-center" });
      });
  };
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  // const secondary = theme.palette.secondary.main;
  // const secondarylight = '#f5fcff';
  // const errorlight = '#fdede8';
  // const lgUp = useMediaQuery((theme)=>theme.breakpoints.up('lg'))
  // console.log(wallet)
  // const optionscolumnchart = {
  //   chart: {
  //     type: 'area',
  //     fontFamily: "'Plus Jakarta Sans', sans-serif;",
  //     foreColor: '#adb0bb',
  //     toolbar: {
  //       show: false,
  //     },
  //     height: 60,
  //     sparkline: {
  //       enabled: true,
  //     },
  //     group: 'sparklines',
  //   },
  //   stroke: {
  //     curve: 'smooth',
  //     width: 2,
  //   },
  //   fill: {
  //     colors: [secondarylight],
  //     type: 'solid',
  //     opacity: 0.05,
  //   },
  //   markers: {
  //     size: 0,
  //   },
  //   tooltip: {
  //     theme: theme.palette.mode === 'dark' ? 'dark' : 'light',
  //   },
  // };
  // const seriescolumnchart = [
  //   {
  //     name: '',
  //     color: secondary,
  //     data: [25, 66, 20, 40, 12, 58, 20],
  //   },
  // ];

  return (
    <DashboardCard
      title={""}
      footer={
        !lgDown ? (
          user && !user?.isEmailVerified ? (
            <Alert
              variant="outlined"
              icon={<IconMail color="black"></IconMail>}
              sx={{
                display: { xs: "none", lg: "flex" },
                opacity: 1,
                bgcolor: "#F5F5F5",
                color: "#E65100",
                minHeight: "64px",
                paddingBottom: 12,
              }}
            >
              <AlertTitle>Important!</AlertTitle>
              Please Verify your{" "}
              <Button
                variant="text"
                sx={{
                  p: 0,
                  m: 0,
                  display: "inline-block",
                  verticalAlign: "baseline",
                  height: "20px",
                  minWidth: "40px",
                  width: "40px",
                  fontSize: "small",
                }}
                onClick={sendVerifyEmail}
              >
                Email
              </Button>{" "}
              to Receive Leads and Payment Notification update
            </Alert>
          ) : (
            <Alert
              variant="outlined"
              icon={<IconCalendarTime color="black" />}
              sx={{
                display: { xs: "none", lg: "flex" },
                opacity: 1,
                bgcolor: "#F5F5F5",
                color: "#E65100",
                minHeight: "64px",

                paddingBottom: 12,
              }}
            >
              <AlertTitle>Note</AlertTitle>
              Pending amount will be tranfered to your bank account by today
            </Alert>
          )
        ) : null
      }
    >
      <Grid
        container
        xs={12}
        spacing={2}
        sx={{ mb: { md: 0 }, height: { xs: "65px", lg: "100px" } }}
      >
        <Grid
          item
          xs={2}
          sx={{ minWidth: lgDown ? "45px" : "75px", paddingTop: 0, mt: -2 }}
        >
          <IconWallet
            width={{ lg: 64, md: 32, sm: 42 }}
            height={{ lg: 64, md: 32, sm: 42 }}
            style={{ color: theme.palette.earnpati.success, minWidth: 42 }}
          />
        </Grid>
        <Grid container xs={9} spacing={1} sx={{ pl: 2 }}>
          <Grid item xs={12}>
            <Typography
              variant={lgDown ? "p" : "h4"}
              mt={lgDown ? 0 : ""}
              sx={{ fontSize: "14px", whiteSpace: "pre", ml: 1 }}
            >
              Balance
            </Typography>
          </Grid>
          <Grid item xs={12} justifyContent={"center"} spacing={3}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              fontWeight="700"
              ml={1}
            >
              <Typography
                variant={lgDown ? "h5" : "h4"}
                style={{ marginRight: "5px" }}
              >
                Rs.
              </Typography>
              <Typography variant={lgDown ? "h5" : "h4"}>
                {wallet?.totalBalance || wallet?.totalBalance == 0 ? (
                  wallet?.totalBalance.toFixed(2) || "0"
                ) : (
                  <TailSpin height={25} width={75} style={{ margin: "auto" }} />
                )}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
      <ToastContainer />
    </DashboardCard>
  );
};

export default TotalBalance;
